/**
 * Nhãn cho hộp thoại xuất MỘT chứng từ (CSV / PDF / Excel).
 *
 * Trước đây bộ nhãn này tên là `piExport` và chỉ hoá đơn chiếu lệ dùng. Hệ quả
 * là mọi chứng từ khác chỉ có nút Xuất tải thẳng CSV, không hỏi gì — người
 * dùng nhìn nút đó rồi kết luận hệ thống không xuất được PDF, dù bản in vẫn
 * lưu PDF được. Nay mọi chứng từ dùng chung một hộp thoại nên nhãn cũng chung.
 */
export const docExportEn = {
  csv: 'CSV (.csv)',
  csvHint: 'Line data for reconciliation. UTF-8; amounts are plain numbers so formulas work.',
  excel: 'Excel (.xlsx)',
  excelHint: 'Editable worksheet laid out like the print template, with the company details and item table.',
  pdf: 'PDF',
  pdfHint: 'Uses the print template. Select “Save as PDF” as the destination in the print dialog.',
  pdfAction: 'Save as PDF',
  preparing: 'Preparing Excel…',
  downloaded: 'Excel download started.',
  failed: 'Could not export this document. Please try again.',
  logoMissing: 'Excel downloaded with the company name. The logo could not be loaded.',
};
export const docExportVi = {
  csv: 'CSV (.csv)',
  csvHint: 'Dữ liệu dòng hàng để đối soát. UTF-8; tiền là số trần nên công thức chạy được.',
  excel: 'Excel (.xlsx)',
  excelHint: 'Bảng tính sửa được, bố trí theo mẫu in, có thông tin công ty và bảng hàng.',
  pdf: 'PDF',
  pdfHint: 'Dùng mẫu in hiện tại. Chọn “Save as PDF / Lưu thành PDF” ở mục máy in trong hộp thoại in.',
  pdfAction: 'Lưu thành PDF',
  preparing: 'Đang tạo Excel…',
  downloaded: 'Đã bắt đầu tải Excel.',
  failed: 'Không xuất được chứng từ này. Vui lòng thử lại.',
  logoMissing: 'Đã tải Excel có tên công ty. Logo chưa tải được.',
};
export const docExportZh = {
  csv: 'CSV (.csv)',
  csvHint: '用于核对的明细数据。UTF-8；金额为纯数字，可直接用于公式计算。',
  excel: 'Excel (.xlsx)',
  excelHint: '可编辑工作表，依打印模板排列，含公司信息与明细表。',
  pdf: 'PDF',
  pdfHint: '使用现有打印模板。在打印对话框中将目标打印机选为“另存为PDF”。',
  pdfAction: '另存为PDF',
  preparing: '正在创建Excel…',
  downloaded: '已开始下载Excel。',
  failed: '无法导出此单据，请重试。',
  logoMissing: '已下载包含公司名称的Excel，但无法加载标志。',
};
